<template>
  <div class="bs-wrapper auth-box"></div>
</template>

<script>
import { routes } from '@/router';
import * as types from '@/store/mutation-types';
// import { isAndroid } from '@utils/bridge';

export default {
  name: 'Auth',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.getUserInfo();
  },

  destroyed() {},

  methods: {
    getUserInfo() {
      /**
       * 对于404处理
       */
      const { module } = this.$route.params;
      const whiteList = ['suggest'];
      if (whiteList.includes(module)) {
        return this.$router.replace({ path: '/share/suggest', query: this.$route.query });
      }
      if (!routes.map((item) => item.name).includes(module))
        return this.$router.replace({ name: 'not-found' });

      // const authWhiteList = routes.filter(item => item.authWhite);

      /**
       * 对于无token处理
       * @type {string|*|string}
       */
      const token = this.$bsUtils.getUrlParams('token');
      console.log('***',token);
      if (!token) return this.$router.replace({ name: 'no-power' });

      /**
       * 获取用户信息并存储
       */
      this.$bsUtils.nativeApi
        .getUserInfo()
        .then((res) => {
          console.log(res);
          this.dealWith(module, res);
        })
        .catch((err) => {
          this.$bsUtils.toast(err.message || '获取用户信息失败');
          this.$router.replace({ name: 'no-power' });
        });
    },
    async dealWith(module, res) {
      // const [err, res] = await this.$bsUtils.request(
      //   this.$bsUtils.nativeApi.getUserInfo()
      // );

      // if (err) return this.$router.replace({ name: 'no-power' });

      if (await this.saveAccountStore(res)) {
        await this.$router.replace({ name: module, query: this.$route.query });
      }
    },
    /**
     * 存储用户信息
     * @param res
     * @returns {Promise<boolean>}
     */
    async saveAccountStore(res) {
      this.$store.commit('base/setUserInfo', res);
      
      await this.$store.dispatch(`account/${types.ACCOUNT_TOKEN}`, res.token);
      await this.$store.dispatch(
        `account/${types.ACCOUNT_USER_ID}`,
        res.userId
      );
      await this.$store.dispatch(`account/${types.ACCOUNT_NAME}`, res.name);
      await this.$store.dispatch(
        `account/${types.ACCOUNT_PLAZA_NAME}`,
        res.plazaName
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_PLAZA_ID}`,
        res.plazaId
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_TENANT_ID}`,
        res.tenantId
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_ROLE_TYPE}`,
        res.roleType
      );
      await this.$store.dispatch(
        `account/${types.ACCOUNT_STORE_ID}`,
        res.storeId
      );
      await this.$store.dispatch(
        `base/${types.BASE_STORE_NAME}`,
        res.storeName
      );

      await this.$store.dispatch(`account/${types.ACCOUNT_MOBILE}`, res.mobile);

      localStorage.setItem(
        'account',
        JSON.stringify(this.$store.state.account)
      );

      localStorage.setItem('token', res.token);

      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.sh-button {
  margin: 20px;
}
</style>
